module.exports = __webpack_public_path__ + "static/LucasPope1-edcb118960ec8cb058f67abc64f76b5b.webp";